import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { LitElement, css, html, nothing } from "lit";
import { property, state } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import "@progressive-development/pd-content/pd-collapse-group";
import "@progressive-development/pd-content/pd-collapse";
import "@progressive-development/pd-composite/pd-contact";
import "@progressive-development/pd-forms/pd-checkbox";
//#region src/pd-order-contacts/PdOrderContacts.ts
var PdOrderContacts = class PdOrderContacts extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.summary = false;
		this.contactTitle = {};
		this.requiredFields = [];
		this.withPayment = false;
		this.withPropertyOwner = false;
		this.withPropertyDate = false;
		this._activeSections = /* @__PURE__ */ new Set();
		this._emptyContactCache = {};
		this._ownBillingContact = false;
		this._ownAdminContact = false;
		this._isPropertyOwner = false;
	}
	static {
		this.styles = [css`
      :host {
        display: block;
      }

      p {
        color: var(--pd-default-font-content-col);
        font-size: var(--pd-default-font-content-size);
        font-family: var(--pd-default-font-content-family);
        max-width: 1000px;
      }

      a {
        cursor: pointer;
        font-family: var(--pd-default-font-link-family);
        font-size: var(--pd-default-font-link-size);
        color: var(--pd-default-font-link-col);
      }

      a:hover {
        color: var(--pd-default-font-link-col-hover);
      }

      .collapse-contact {
        padding: 10px;
      }

      .summary-box {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
      }

      .summary-box pd-contact {
        min-width: 150px;
      }

      .property-owner-box {
        border: 2px solid var(--pd-default-col);
        border-radius: var(--pd-radius-lg);
        padding: var(--pd-spacing-lg);
        margin: var(--pd-spacing-lg) 0;
        background-color: var(--pd-default-bg-light-col);
        box-shadow: var(--pd-shadow-md);
      }
    `];
	}
	update(changedProps) {
		if (changedProps.has("billingContact")) this._ownBillingContact = !!this.billingContact;
		if (changedProps.has("adminContact")) this._ownAdminContact = !!this.adminContact;
		if (changedProps.has("propertyContact")) this._isPropertyOwner = !!this.propertyContact;
		if (changedProps.has("sectionData") && this.sectionData && this.contactSections) {
			const active = /* @__PURE__ */ new Set();
			for (const section of this.contactSections) if (section.optional && this.sectionData[section.key]) active.add(section.key);
			this._activeSections = active;
		}
		super.update(changedProps);
	}
	render() {
		return this.summary ? this._renderSummary() : this._renderEditContacts();
	}
	_renderEditContacts() {
		if (this.contactSections) return this._renderConfiguredSections();
		return html`
      <pd-collapse-group>
        <pd-collapse id="orderContactCollapseId">
          <div slot="header">
            ${this.contactTitle.orderInputContact ?? msg("Adresse", { id: "pd.order.contacts.orderContact.inputHeader" })}
          </div>
          <pd-contact
            id="orderContactId"
            class="collapse-contact"
            slot="content"
            .requiredFields="${this.requiredFields}"
            .contact="${this.orderContact}"
            .match="${this.match}"
            ?withPropertyDate="${!this._isPropertyOwner && this.withPropertyDate}"
          ></pd-contact>
        </pd-collapse>

        ${this.withPayment ? html`
                <pd-collapse id="billingContactCollapseId">
                  <div slot="header">
                    ${this.contactTitle.billingInputContact ?? msg("Rechnungsadresse (optional)", { id: "pd.order.contacts.billingContact.inputHeader" })}
                  </div>
                  <div slot="content">
                    ${this._ownBillingContact ? html`
                            <p>
                              <a
                                @click="${() => this._ownBillingContact = false}"
                                >${msg("Kundenadresse als Rechnungsadresse verwenden")}</a
                              >
                            </p>
                            <pd-contact
                              id="billingContactId"
                              class="collapse-contact"
                              .requiredFields="${this.requiredFields}"
                              .contact="${this.billingContact}"
                            ></pd-contact>
                          ` : html`
                            <p>
                              ${msg("Rechnungsadresse entspricht der Kundenadresse.")}
                            </p>
                            <p>
                              <a
                                @click=${() => this._ownBillingContact = true}
                                >${msg("Neue Rechnungsadresse hinzufügen")}</a
                              >
                            </p>
                          `}
                  </div>
                </pd-collapse>
              ` : nothing}
        ${this.withPropertyOwner ? html`
                <div class="property-owner-box">
                  <pd-checkbox
                    id="isPropertyOwnerId"
                    initValue="${this._isPropertyOwner}"
                    @pd-form-element-change="${(e) => {
			this._isPropertyOwner = e.detail.value === "true";
		}}"
                  >
                    ${msg("Ist der Kunde Vermieter?", { id: "pd.order.contacts.propertyContact.checkBox" })}
                  </pd-checkbox>

                  ${this._isPropertyOwner ? html`
                          <pd-collapse
                            id="propertyContactCollapseId"
                            style="padding-top: 20px;"
                          >
                            <div slot="header">
                              ${this.contactTitle.propertyInputContact ?? msg("Adresse der Immobilie")}
                            </div>
                            <div slot="content">
                              <pd-contact
                                id="propertyContactId"
                                class="collapse-contact"
                                .requiredFields="${[
			"street",
			"streetNr",
			"zip",
			"city"
		]}"
                                .inputFields="${[
			"street",
			"city",
			"additionalHint"
		]}"
                                .contact="${this.propertyContact}"
                                ?withPropertyDate="${this.withPropertyDate}"
                              ></pd-contact>
                            </div>
                          </pd-collapse>

                          <pd-collapse id="adminContactCollapseId">
                            <div slot="header">
                              ${this.contactTitle.adminInputContact ?? msg("Adresse der Verwaltung (optional)")}
                            </div>
                            <div slot="content">
                              ${this._ownAdminContact ? html`
                                      <p>
                                        <a
                                          @click="${() => this._ownAdminContact = false}"
                                          >${msg("Kundenadresse als Verwaltungsadresse verwenden")}</a
                                        >
                                      </p>
                                      <pd-contact
                                        id="adminContactId"
                                        class="collapse-contact"
                                        .requiredFields="${this.requiredFields}"
                                        .contact="${this.adminContact}"
                                      ></pd-contact>
                                    ` : html`
                                      <p>
                                        ${msg("Verwaltungsadresse entspricht der Kundenadresse.")}
                                      </p>
                                      <p>
                                        <a
                                          @click="${() => this._ownAdminContact = true}"
                                          >${msg("Neue Verwaltungsadresse hinzufügen")}</a
                                        >
                                      </p>
                                    `}
                            </div>
                          </pd-collapse>
                        ` : nothing}
                </div>
              ` : nothing}
      </pd-collapse-group>
    `;
	}
	_renderSummary() {
		if (this.contactSections) return this._renderConfiguredSummary();
		return html`
      <div class="summary-box">
        ${this.orderContact ? html`
                <pd-contact
                  addressTitle="${this.contactTitle.orderSummaryContact ?? msg("Adresse")}"
                  .contact="${this.orderContact}"
                  summary
                ></pd-contact>
              ` : nothing}
        ${this.billingContact ? html`
                <pd-contact
                  addressTitle="${this.contactTitle.billingSummaryContact ?? msg("Rechnungsadresse")}"
                  .contact="${this.billingContact}"
                  summary
                ></pd-contact>
              ` : nothing}
        ${this.propertyContact ? html`
                <pd-contact
                  addressTitle="${this.contactTitle.propertySummaryContact ?? msg("Immobilie")}"
                  .contact="${this.propertyContact}"
                  summary
                ></pd-contact>
              ` : nothing}
        ${this.adminContact ? html`
                <pd-contact
                  addressTitle="${this.contactTitle.adminSummaryContact ?? msg("Verwaltung")}"
                  .contact="${this.adminContact}"
                  summary
                ></pd-contact>
              ` : nothing}
      </div>
    `;
	}
	/** Gibt eine stabile Referenz für den contact-Property-Wert zurück.
	*  Wenn sectionData den Key enthält, wird das echte Objekt zurückgegeben.
	*  Ansonsten ein gecachtes leeres Objekt, damit Lit keinen Property-Change triggert. */
	_getContactData(key) {
		const data = this.sectionData?.[key];
		if (data) return data;
		if (!this._emptyContactCache[key]) this._emptyContactCache[key] = {};
		return this._emptyContactCache[key];
	}
	_renderConfiguredSections() {
		const sections = this.contactSections;
		return html`
      <pd-collapse-group>
        ${sections.map((section) => {
			const isActive = !section.optional || this._activeSections.has(section.key);
			return html`
            <pd-collapse id="${section.key}CollapseId">
              <div slot="header">${section.label}</div>
              <div slot="content">
                ${section.optional ? isActive ? html`
                          <p>
                            <a
                              @click="${() => this._toggleSection(section.key, false)}"
                              >${section.label} deaktivieren</a
                            >
                          </p>
                          <pd-contact
                            id="${section.key}"
                            class="collapse-contact"
                            .contact="${this._getContactData(section.key)}"
                            .inputFields="${section.inputFields ?? []}"
                            .requiredFields="${section.requiredFields ?? []}"
                          ></pd-contact>
                        ` : html`
                          <p>${section.optionalHint ?? ""}</p>
                          <p>
                            <a
                              @click="${() => this._toggleSection(section.key, true)}"
                              >${section.optionalActivateLabel ?? `${section.label} angeben`}</a
                            >
                          </p>
                        ` : html`
                        <pd-contact
                          id="${section.key}"
                          class="collapse-contact"
                          .contact="${this._getContactData(section.key)}"
                          .inputFields="${section.inputFields ?? []}"
                          .requiredFields="${section.requiredFields ?? []}"
                        ></pd-contact>
                      `}
              </div>
            </pd-collapse>
          `;
		})}
      </pd-collapse-group>
    `;
	}
	_renderConfiguredSummary() {
		const sections = this.contactSections;
		return html`
      <div class="summary-box">
        ${sections.map((section) => {
			if (!(!section.optional || this._activeSections.has(section.key))) return nothing;
			const data = this.sectionData?.[section.key];
			if (!data) return nothing;
			return html`
            <pd-contact
              addressTitle="${section.summaryLabel ?? section.label}"
              .contact="${data}"
              summary
            ></pd-contact>
          `;
		})}
      </div>
    `;
	}
	_toggleSection(key, active) {
		const next = new Set(this._activeSections);
		if (active) next.add(key);
		else next.delete(key);
		this._activeSections = next;
	}
	get valid() {
		for (const { id, condition = true } of this._getCollapseMap()) {
			if (!condition) continue;
			if (!(this.shadowRoot?.getElementById(id))?.valid) return false;
		}
		return true;
	}
	async triggerValidate() {
		let firstInvalidCollapseId = null;
		const collapseMap = this._getCollapseMap();
		console.log("Map: ", collapseMap);
		for (const { id, collapse, condition = true } of collapseMap) {
			if (!condition) continue;
			const element = this.shadowRoot?.getElementById(id);
			if (!element) continue;
			const result = await element.triggerValidate();
			console.log("PdContact triggerValidate: ", result);
			if (!result && !firstInvalidCollapseId) firstInvalidCollapseId = collapse;
		}
		if (firstInvalidCollapseId) {
			console.log("PdContact open failed: ", firstInvalidCollapseId);
			const collapseEl = this.shadowRoot?.getElementById(firstInvalidCollapseId);
			if (collapseEl) collapseEl.active = true;
			return false;
		}
		return true;
	}
	getValues() {
		const contactValues = {};
		for (const { id, condition = true } of this._getCollapseMap()) {
			if (!condition) continue;
			contactValues[id] = (this.shadowRoot?.getElementById(id))?.getValues();
		}
		return contactValues;
	}
	_getCollapseMap() {
		if (this.contactSections) return this.contactSections.map((s) => ({
			id: s.key,
			collapse: `${s.key}CollapseId`,
			condition: !s.optional || this._activeSections.has(s.key)
		}));
		return [
			{
				id: "orderContactId",
				collapse: "orderContactCollapseId"
			},
			{
				id: "billingContactId",
				collapse: "billingContactCollapseId",
				condition: this._ownBillingContact
			},
			{
				id: "propertyContactId",
				collapse: "propertyContactCollapseId",
				condition: this._isPropertyOwner
			},
			{
				id: "adminContactId",
				collapse: "adminContactCollapseId",
				condition: this._isPropertyOwner && this._ownAdminContact
			}
		];
	}
};
__decorate([property({ type: Boolean })], PdOrderContacts.prototype, "summary", void 0);
__decorate([property({ type: Object })], PdOrderContacts.prototype, "contactTitle", void 0);
__decorate([property({ type: Array })], PdOrderContacts.prototype, "requiredFields", void 0);
__decorate([property({ type: Object })], PdOrderContacts.prototype, "orderContact", void 0);
__decorate([property({ type: Object })], PdOrderContacts.prototype, "billingContact", void 0);
__decorate([property({ type: Object })], PdOrderContacts.prototype, "adminContact", void 0);
__decorate([property({ type: Object })], PdOrderContacts.prototype, "propertyContact", void 0);
__decorate([property({ type: Boolean })], PdOrderContacts.prototype, "withPayment", void 0);
__decorate([property({ type: Boolean })], PdOrderContacts.prototype, "withPropertyOwner", void 0);
__decorate([property({ type: Boolean })], PdOrderContacts.prototype, "withPropertyDate", void 0);
__decorate([property({ type: Object })], PdOrderContacts.prototype, "match", void 0);
__decorate([property({ type: Array })], PdOrderContacts.prototype, "contactSections", void 0);
__decorate([property({ type: Object })], PdOrderContacts.prototype, "sectionData", void 0);
__decorate([state()], PdOrderContacts.prototype, "_activeSections", void 0);
__decorate([state()], PdOrderContacts.prototype, "_ownBillingContact", void 0);
__decorate([state()], PdOrderContacts.prototype, "_ownAdminContact", void 0);
__decorate([state()], PdOrderContacts.prototype, "_isPropertyOwner", void 0);
PdOrderContacts = __decorate([localized()], PdOrderContacts);
//#endregion
export { PdOrderContacts };
